// 兼容IE浏览器
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()

import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
import "@/assets/css/theme/index.css";
import "@/styles/element-variables.scss";
Vue.use(ElementUI);
import router from "./router";
import store from "./store";
import "./permission"; // permission control
import * as filters from "./filters"; // global filters
//全局方法
import * as utils from "./utils";
Vue.prototype.utils = utils;

// register global utility filters.
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
import "@/styles/index.scss"; // global css
import "@/styles/style.less"; // global css
Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App,
  },
});
